var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',[_vm._v("HomeView")]),_c('br'),_c('ButtonPlain',{attrs:{"label":"Clear learning progress"},on:{"click":function($event){return _vm.clearLearningProgress()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }